import { useState } from 'react';
import { useToast } from '../../lib/use-toast';
import { resetUserPassword, type UserListItem } from './users.api';

/** Split out of `useUsers` to keep each hook under the line limit — a form action, so its failure stays inline (CLAUDE.md → Web conventions). */
export function useResetPassword() {
  const [resetPasswordError, setResetPasswordError] = useState<string | null>(null);
  const [resettingPassword, setResettingPassword] = useState(false);
  const toast = useToast();

  /** Returns whether it succeeded, so the drawer knows to close itself — same shape as `useUsers.create`. */
  async function resetPassword(user: UserListItem, password: string): Promise<boolean> {
    setResetPasswordError(null);
    setResettingPassword(true);
    try {
      await resetUserPassword(user.id, password);
      toast.success(`Password reset for ${user.name} — they'll set a new one at next sign-in.`);
      return true;
    } catch {
      setResetPasswordError("Couldn't reset the password — check the field and try again.");
      return false;
    } finally {
      setResettingPassword(false);
    }
  }

  return { resetPasswordError, resettingPassword, resetPassword, resetResetPasswordError: () => setResetPasswordError(null) };
}
